export default __webpack_public_path__ + "static/media/1216.c388c9a2.png";